import { render } from "./header.vue?vue&type=template&id=07afa95c"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/one_eu/web_head/releases/20260421203947/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__